import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { getMapValue } from '../../utils';

const CheckboxField = (props) => {
	const { input, label, placeholder, required, type, meta: { touched, error }, formErrors } = props;
	return (
		<React.Fragment>
		  <div className="form-check">
        <input
					{...input}
					type={type}
					placeholder={placeholder}
					className="form-check-input"   
				/>
        <label className="form-check-label">Ik bevestig bovenstaande gegevens correct te hebben ingevuld</label>
      </div>
			{touched && (error && <small className="form-text text-danger mb-0">{error}</small>)}
		</React.Fragment>

	);
}

export default CheckboxField;

